// @flow

import * as React from 'react';

import { useTranslator } from '@gandi/translate';
import { Badge } from '@gandi/ui';

import { DomainDiscountPercentBadge } from '../../DomainCreate/components/DiscountPercentBadge';

type Props = {
  fqdn?: string,
  type: 'premium' | 'cheap-renew' | 'discount',
};

function FqdnBadge({ fqdn, type }: Props) {
  const { __ } = useTranslator();

  if (type === 'discount' && fqdn)
    return <DomainDiscountPercentBadge fqdn={fqdn} />;

  return (
    <Badge
      intent={type === 'premium' ? 'primary' : 'promotional'}
      transform="capitalize"
    >
      {type === 'premium' ? __('premium') : __('lower renew price')}
    </Badge>
  );
}

export default (React.memo<Props>(FqdnBadge): React.ComponentType<Props>);
